import React from "react";
import ButtonStyles from "./Button.styles";
import { DefaultButtonProps, IButtonProps } from "./Button.types";

const renderButton = (props: IButtonProps) => {
  const { label, children, type, disabled, size, onClick, className, testid } =
    props;
  const variant = props.variant ? props.variant : "primary";
  if (label) {
    return (
      <ButtonStyles.CECSSOButton
        type={type}
        disabled={disabled}
        size={size}
        variant={variant}
        onClick={onClick}
        className={`${variant} ${className} ce-CSSO-button`}
        data-testid={`${testid}`}
      >
        {label}
      </ButtonStyles.CECSSOButton>
    );
  } else if (children) {
    return (
      <ButtonStyles.CECSSOButton
        type={type}
        disabled={disabled}
        size={size}
        variant={variant}
        onClick={onClick}
        className={`${variant} ${className} ce-CSSO-button`}
        data-testid={`${testid}`}
      >
        {children}
      </ButtonStyles.CECSSOButton>
    );
  } else {
    return (
      <ButtonStyles.CECSSOButton
        type={type}
        disabled={disabled}
        size={size}
        variant={variant}
        onClick={onClick}
        className={`${variant} ${className} ce-CSSO-button`}
        data-testid={`${testid}`}
      >
        CE CSSO BUTTON
      </ButtonStyles.CECSSOButton>
    );
  }
};

const BUTTON: React.FC<IButtonProps> = (props: IButtonProps) => {
  return renderButton(props);
};

BUTTON.defaultProps = DefaultButtonProps;

export default BUTTON;
